module.exports = __webpack_public_path__ + "img/Contact.a3ac26bf.jpeg";